export default __webpack_public_path__ + "static/media/img3.94d90429.png";